import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    processes: []
  },

  mutations: {
    updateProcesses (state, processes) {
      Vue.set(state, 'processes', processes)
    }
  }
}
